export default __webpack_public_path__ + "static/media/gopher.85597fdd.webp";